import { BuscarCautelasCarrinhoDto } from "@/dtos/Request/RequestBuscarCautelasCarrinho";
import { apiApp } from "./ApiApp";
import { ApiResult } from "./ApiResult";
import { DadosCompraCartaoCreditoDto, DadosCompraPixDto, DadosCompraSaldoDto } from "@/dtos/Request/RequestDadosCompraCartaoCreditoDto";
import { QrCodeGeradoDto } from "@/dtos/QrCodeGeradoDto";
import { EncryptData } from "@/utils/EncryptData";
import { CadastrarPresenteado, PresenteadoDto } from "./AcessoService";

class AppService {
    async buscarSaldoCreditoApp(token: string) {
        let { data: result } = await apiApp.get<ApiResult<number>>('Acesso/BuscarSaldoCredito', {
            headers: {
                Authorization: token
            }
        });

        return result;
    }

    async buscarCautelasCarrinhoApp(token: string) {
        let { data: result } = await apiApp.get<ApiResult<BuscarCautelasCarrinhoDto>>(`Cautela/BuscarCautelasCarrinho`, {
            headers: {
                Authorization: token
            }
        });

        return result;
    }

    async VerificarCartaoCreditoHabilitadoApp(token: string) {
        const { data: result } = await apiApp.get<ApiResult<boolean>>('Compra/VerificarCartaoCreditoHabilitado', {
            headers: {
                Authorization: token
            }
        });
        return result;
    }

    async buscarPresenteados(token: string) {
        let { data: result } = await apiApp.get<ApiResult<PresenteadoDto[]>>('Acesso/BuscarPresenteados', {
            headers: {
                Authorization: token
            }
        });

        return result;
    }

    async removerPresenteado(idUsuario: number, token: string) {
        let { data: result } = await apiApp.post<ApiResult<any>>('Acesso/RemoverPresenteado/', { idUsuario }, {
            headers: {
                Authorization: token
            }
        });

        return result;
    }

    async adicionarPresenteado(presenteado: CadastrarPresenteado, token: string) {
        let { data: result } = await apiApp.post<ApiResult<any>>('Acesso/CadastrarPresenteado/', presenteado, {
            headers: {
                Authorization: token
            }
        });

        return result;
    }

    async FinalizarCompraCartaoCreditoApp(dadosCompra: DadosCompraCartaoCreditoDto, token: string) {
        dadosCompra.Origem = 'IOS';
        const dados = await EncryptData(dadosCompra);
        let { data: result } = await apiApp.post<ApiResult<any>>("Compra/EfetuarPagamento", { dados }, {
            headers: {
                Authorization: token
            }
        });
        return result;
    }

    async FinalizarCompraSaldoApp(dadosCompra: DadosCompraSaldoDto, token: string) {
        dadosCompra.Origem = 'IOS';
        const dados = await EncryptData(dadosCompra);
        let { data: result } = await apiApp.post<ApiResult<any>>("Compra/EfetuarPagamento", { dados }, {
            headers: {
                Authorization: token
            }
        });
        return result;
    }

    async FinalizarCompraPixApp(dadosCompra: DadosCompraPixDto, token: string) {
        dadosCompra.Origem = 'IOS';
        const dados = await EncryptData(dadosCompra);
        let { data: result } = await apiApp.post<ApiResult<QrCodeGeradoDto>>("Compra/EfetuarPagamento", { dados }, {
            headers: {
                Authorization: token
            }
        });
        return result;
    }
}

//eslint-disable-next-line
export default new AppService();